<template>
  <div class="animated fadeInRight ecommerce">
    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <div>查询条件</div>
      </div>
      <div class="">
        <el-form :inline="true" class="flex flex-wrap justify-start align-center">
          <el-form-item style="margin-bottom: 10px;">
            <el-button type="primary" size="small" @click="queryOrders()">
              <i class="el-icon-search"></i> 查询
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="ibox margin-top-sm">
      <div slot="header" class="flex justify-between">
        <div>异常订单信息</div>
      </div>
      <div class="">
        <el-table :data="orders" style="width: 100%" border stripe>
          <el-table-column prop="orderId" label="订单号" align="center"></el-table-column>
          <el-table-column label="店铺" align="center">
            <template slot-scope="scope">
              {{ scope.row.shopName || '-' }}
            </template>
          </el-table-column>
          <el-table-column label="买家姓名" align="center">
            <template slot-scope="scope">
              {{ scope.row.personName || '-' }}
            </template>
          </el-table-column>
          <el-table-column label="买家电话" align="center">
            <template slot-scope="scope">
              {{ scope.row.tel || '-' }}
            </template>
          </el-table-column>
          <el-table-column label="订单金额" align="right">
            <template slot-scope="scope">
              {{ scope.row.payPrice || '0.00' }}
            </template>
          </el-table-column>
          <el-table-column label="运费" align="right">
            <template slot-scope="scope">
              {{ scope.row.freightPrice || '0.00' }}
            </template>
          </el-table-column>
          <el-table-column label="配送方" align="center">
            <template slot-scope="scope">
              {{ deliveryTypeName(scope.row.deliveryType) }}
            </template>
          </el-table-column>
          <el-table-column prop="deliveryAssignCount" label="分配次数" align="center"></el-table-column>
          <el-table-column prop="deliveryRejectCount" label="拒单次数" align="center"></el-table-column>
          <el-table-column prop="createTime" label="下单时间" align="center"></el-table-column>
          <el-table-column label="地址" align="center" width="180" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ (scope.row.storeOrderAddressDto && scope.row.storeOrderAddressDto.address) || '-' }}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="130">
            <template slot-scope="scope">
              <el-button size="mini" type="warning" @click="manualAssign(scope.row)">
                手动分配回池
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @current-change="handlePageChange" :current-page="conditions.page" :page-size="conditions.row"
          layout="total, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import { queryExceptionOrders, manualAssignDelivery } from '@/api/order/adminDeliveryApi'

export default {
  name: 'ExceptionOrderManage',
  data() {
    return {
      orders: [],
      total: 0,
      records: 0,
      conditions: {
        page: 1,
        row: 10
      }
    }
  },
  created() {
    this.listOrders()
  },
  methods: {
    deliveryTypeName(deliveryType) {
      if (deliveryType === 'STORE') {
        return '商家自配送'
      }
      if (deliveryType === 'PROPERTY') {
        return '物业配送'
      }
      return deliveryType || '-'
    },
    async listOrders() {
      try {
        const res = await queryExceptionOrders(this.conditions)
        this.total = res.total
        this.records = res.records
        this.orders = res.data || []
      } catch (error) {
        console.error('请求失败处理', error)
      }
    },
    handlePageChange(val) {
      this.conditions.page = val
      this.listOrders()
    },
    queryOrders() {
      this.conditions.page = 1
      this.listOrders()
    },
    manualAssign(order) {
      this.$confirm('订单将回到抢单池并清零分配计数，确认执行手动分配回池吗？', '提示', {
        type: 'warning'
      }).then(async () => {
        try {
          const res = await manualAssignDelivery({ orderId: order.orderId })
          if (res.code === 0) {
            this.$message.success('手动分配回池成功')
            this.listOrders()
          }
        } catch (error) {
          console.error('请求失败处理', error)
        }
      }).catch(() => {
        // 用户取消操作，无需处理
      })
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
}

.margin-top-sm {
  margin-top: 20px;
}
</style>
